module.exports = __webpack_public_path__ + "img/retro_sec5.d9a95acc.jpg";